import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "regenerator-runtime/runtime.js";
import Vue from 'vue';
import universityBranding from '~/mixins/universityBranding';
export default Vue.extend({
  name: 'AuthLayout',
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.attemptLogin();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mixins: [universityBranding],
  computed: {
    isFaq: function isFaq() {
      return this.$router.currentRoute.path === 'faqs';
    }
  },
  methods: {
    logout: function logout() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('login/logout').then(function (response) {
                  _this2.$toast.success('Successfully logged out!');

                  _this2.$router.push(_this2.localePath({
                    path: '/login'
                  }));
                }).catch(function (error) {
                  console.error(error);
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    goToFaq: function goToFaq() {
      this.$router.push(this.localePath({
        path: '/faqs'
      }));
    },

    /**
     * Fetch the user and redirect them to the dashboard if they have an active session.
     *
     * @note This method serves as a fix for when a user (without an OAuth account)
     *       reopens the browser after a session was created. The user will be redirected
     *       to the login page. Attempting to log in again will lead to a CORS error.
     */
    attemptLogin: function attemptLogin() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.$auth.fetchUser().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (_this3.$auth.loggedIn) {
                            _context3.next = 2;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 2:
                          _context3.next = 4;
                          return _this3.$router.replace({
                            path: '/'
                          });

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
});